export const addSpaceBetweenLatexCommandAndDynamicParamChar = (latex) => {
  const latexCommandWithDynamicVariableRegex = /(\\[a-zA-Z]+)(@([a-zA-Z]))/g
  const updatedLatex = latex.replace(
    latexCommandWithDynamicVariableRegex,
    (match, command, dynamicVariable) => `${command} ${dynamicVariable}`
  )
  return updatedLatex
}
